// this is simmiler to AboutCancer.js
import React from "react";
import { Helmet } from "react-helmet";
import InstagramEmbed from "./InstagramEmbed";

const BaatKarCancerPar = () => {
  return (
    <>
      <Helmet>
        <title>Know About Cancer And It's Treatments - Cope With Cancer</title>

        <meta
          name="description"
          content="About cancer: Cancer is a disease in which abnormal cells divide uncontrollably and destroy body tissue. It is caused by mutations to the DNA within cells."
        />
        <meta name="robots" content="noodp" />
        <link
          rel="canonical"
          href="https://www.copewithcancer.org/about-cancer"
        />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="article" />
        <meta
          property="og:title"
          content="Know About Cancer And It's Treatments - Cope With Cancer"
        />
        <meta
          property="og:description"
          content="About cancer: Cancer is a disease in which abnormal cells divide uncontrollably and destroy body tissue. It is caused by mutations to the DNA within cells."
        />
        <meta
          property="og:url"
          content="https://www.copewithcancer.org/about-cancer"
        />
        <meta property="og:site_name" content="Cope with Cancer" />
        <meta
          property="article:publisher"
          content="https://www.facebook.com/copewithcancer/"
        />
        <meta name="twitter:card" content="summary" />
        <meta
          name="twitter:description"
          content="About cancer: Cancer is a disease in which abnormal cells divide uncontrollably and destroy body tissue. It is caused by mutations to the DNA within cells."
        />
        <meta
          name="twitter:title"
          content="Know About Cancer And It's Treatments - Cope With Cancer"
        />
        <meta name="twitter:site" content="@copewithcancer" />
        <meta name="twitter:creator" content="@copewithcancer" />
        <meta property="DC.date.issued" content="2016-05-05T12:15:00+00:00" />
      </Helmet>

      <div className="topspace">
        <div className="contentBox">
          <div className="container">
            <h1 className="Bold28 mb20"> Baat Kar Cancer Par </h1>
            <div className="row">
              <div className="col-md-4 mb30">
                <InstagramEmbed
                  url={
                    "https://www.instagram.com/reel/DGLD3LyzsyO/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA%3D%3D"
                  }
                />
              </div>
              <div className="col-md-4 mb30">
                <iframe
                  className="videoYoutube media100 mediaMB40"
                  title="CWC General Activities - 2022"
                  width="1170"
                  height="658"
                  src="https://www.youtube.com/embed/m25Z9zUyEQU?feature=oembed&amp;hd=1;rel=0;showinfo=0&amp;controls=2&amp;theme=light&amp;modestbranding=1"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </div>
              <div className="col-md-4 mb30">
                <iframe
                  className="videoYoutube media100 mediaMB40"
                  title="CWC General Activities - 2022"
                  width="1170"
                  height="658"
                  src="https://www.youtube.com/embed/9J-BJrIjvyM?feature=oembed&amp;hd=1;rel=0;showinfo=0&amp;controls=2&amp;theme=light&amp;modestbranding=1"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </div>
              <div className="col-md-4 mb30">
                <iframe
                  className="videoYoutube media100 mediaMB40"
                  title="CWC General Activities - 2022"
                  width="1170"
                  height="658"
                  src="https://www.youtube.com/embed/N1eZMY8W7TY?feature=oembed&amp;hd=1;rel=0;showinfo=0&amp;controls=2&amp;theme=light&amp;modestbranding=1"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </div>
              <div className="col-md-4 mb30">
                <div style={{ padding: "16px" }}>
                  <h3
                    style={{
                      margin: "0 0 10px",
                      fontWeight: "600",
                      color: "#333",
                    }}
                  >
                    🎙️ Fight Cancer with Dr. Prasad
                  </h3>
                  <p style={{ marginBottom: "16px", color: "#666" }}>
                    Listen to more in-depth conversations and expert insights on
                    various aspects of cancer care by tuning into the "Fight
                    Cancer with Dr. Prasad" podcast.
                  </p>

                  <a
                    href="https://tinyurl.com/2k6hy8tb"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: "inline-block",
                      backgroundColor: "#cc0000",
                      color: "#fff",
                      padding: "10px 20px",
                      borderRadius: "8px",
                      textDecoration: "none",
                      fontWeight: "500",
                    }}
                  >
                    ▶️ Visit YouTube Channel
                  </a>
                </div>
              </div>
            </div>
            {/* <Pagination totalRecords={totalRecords} /> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default BaatKarCancerPar;
